import PropTypes from 'prop-types';
import React from 'react';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const Cell = CSSModules(
  ({ content, percentage, align, ...rest }) => {
    const style = {
      textAlign: align,
      flex: `0 0 ${percentage}`,
      maxWidth: `${percentage}`,
      paddingRight: 0,
      paddingLeft: 0,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    };
    return (
      <div style={style} {...rest}>
        {content}
      </div>
    );
  },
  styles,
  { allowMultiple: true }
);

const Row = CSSModules(
  ({ contents, columns, ...rest }) => {
    const n = columns.reduce((sum, c) => sum + (c.size || 1), 0);
    return (
      <div styleName="row" {...rest}>
        {contents.map((c, i) => {
          const percentage = `${Math.floor(((columns[i].size || 1) / n) * 100)}%`;
          return (
            <Cell content={c.data} percentage={percentage} align={c.align || 'center'} key={i} />
          );
        })}
      </div>
    );
  },
  styles,
  { allowMultiple: true }
);

const TableRows = ({ rows, columns, ...rest }) => {
  return (
    <div {...rest}>
      {rows?.map((row, i) => (
        <Row contents={row} columns={columns} key={i} />
      ))}
    </div>
  );
};

TableRows.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.array).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      size: PropTypes.number,
    })
  ).isRequired,
};

export default CSSModules(TableRows, styles, { allowMultiple: true });
